import { chargingPointStatusUtils } from '@/utils/chargingPointStatus'

import ChargingPointScreenTemplate from './template/ChargingPointScreenTemplate'
import { ChargingPointScreenProps } from './types'

import ChargingSessionBody from '../components/ChargingSessionBody'

const FaultedChargingPointScreen: React.FC<ChargingPointScreenProps> = (props) => {
  return (
    <ChargingPointScreenTemplate
      {...props}
      Body={
        <ChargingSessionBody
          message={
            <>
              Carregador <b style={{ color: chargingPointStatusUtils.getColorValue('FAULTED') }}>com defeito</b> no
              momento.
            </>
          }
        />
      }
    />
  )
}

export default FaultedChargingPointScreen
